module.exports = __webpack_public_path__ + "static/media/estilosos_feminino_acessorios.6ce44c16.jpg";